/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ListOf1OfPolicyDto } from '../models/ListOf1OfPolicyDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PoliciesService {
    /**
     * **Required Policy:** `ViewPolicies`
     * @returns ListOf1OfPolicyDto OK
     * @throws ApiError
     */
    public static getBaseRolesAdmin(): CancelablePromise<ListOf1OfPolicyDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/policies',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
